@if (deviceTypeIcon(); as icon) {
    <sona-icon [name]="icon" size="small"></sona-icon>
}

@switch (state()) {
    @case ('pending') {
        <sona-spinner
            size="xxs"
            [attr.aria-label]="
                'UI_COMPONENTS.SCAN_STATE.LOADING_MESSAGE' | translate
            "
        ></sona-spinner>
    }
    @case ('error') {
        <sona-icon
            class="text-danger"
            name="x"
            size="small"
            [attr.aria-label]="
                'UI_COMPONENTS.SCAN_STATE.ERROR_MESSAGE' | translate
            "
        ></sona-icon>
    }
    @case ('aborted') {
        <sona-icon
            class="text-warning"
            name="x"
            size="small"
            [attr.aria-label]="
                'UI_COMPONENTS.SCAN_STATE.ABORTED_MESSAGE' | translate
            "
        ></sona-icon>
    }
    @case ('finished') {
        @if (score() != null) {
            <span [sonaRatingColor]="score()">{{
                (score() ?? 0) * 100 | number: '1.0-0'
            }}</span>
        }
    }
}
